export default __webpack_public_path__ + "a05a724ce7f4badb69cab9106ee0f1c4.webp";